// import { defaultLocale, localeOptions } from '../../constants/defaultValues'

import {

	LOGOUT_USER,
	BOOKING_LOAD_BOOKING_LIST,
	BOOKING_LOAD_BOOKING_LIST_SUCCESS,
	BOOKING_LOAD_BOOKING_LISTS,
	BOOKING_LOAD_BOOKING_LISTS_SUCCESS,
	BOOKING_LOAD_ALL_PAYMENT_BOOKING_LIST_SUCCESS,
	BOOKING_LOAD_REVIEW,
	BOOKING_LOAD_REVIEW_SUCCESS,
	BOOKING_UPDATE_SHOW_REVIEW,
	BOOKING_UPDATE_SHOW_REVIEW_SUCCESS,
	BOOKING_LOAD_REVIEW_CHAT,
	BOOKING_LOAD_REVIEW_CHAT_SUCCESS,
	BOOKING_SEND_REVIEW_CHAT_ADMIN,
	BOOKING_SEND_REVIEW_CHAT_ADMIN_SUCCESS,
	BOOKING_READ_REVIEW_CHAT,
	BOOKING_READ_REVIEW_CHAT_SUCCESS,
} from '../actions';

const INIT_STATE = {

	BookingLoading: false,
	bookinglist: null,
	bookinglists: null,
	allPaymentBookinglist: null,
	reviewList: [],
	reviewChat: [],

	reviewChatSending: false,
	sendReviewChatResult: null,
	// dataCompanyInformation: null,

};

export default (state = INIT_STATE, action) => {
	switch (action.type) {
		case BOOKING_LOAD_BOOKING_LIST:
			return { ...state, BookingLoading: true, }
		case BOOKING_LOAD_BOOKING_LIST_SUCCESS:
			return { ...state, BookingLoading: false, bookinglist: action.payload }
		case BOOKING_LOAD_BOOKING_LISTS:
			return { ...state, BookingLoading: true, }
		case BOOKING_LOAD_BOOKING_LISTS_SUCCESS:
			return { ...state, BookingLoading: false, bookinglists: action.payload }
		case BOOKING_LOAD_ALL_PAYMENT_BOOKING_LIST_SUCCESS:
			return { ...state, BookingLoading: false, allPaymentBookinglist: action.payload }
		case BOOKING_LOAD_REVIEW:
			return {
				...state,
				BookingLoading: true,
			};
		case BOOKING_LOAD_REVIEW_CHAT:
			return {
				...state,
				BookingLoading: true,
			};
		case BOOKING_UPDATE_SHOW_REVIEW:
			return {
				...state,
				BookingLoading: true,
			};

		case BOOKING_UPDATE_SHOW_REVIEW_SUCCESS:
			return {
				...state,
				BookingLoading: false,
			};
		case BOOKING_LOAD_REVIEW_SUCCESS:
			return {
				...state,
				BookingLoading: false,
				reviewList: action.payload,
			};
		case BOOKING_LOAD_REVIEW_CHAT_SUCCESS:
			return {
				...state,
				BookingLoading: false,
				reviewChat: action.payload,
			};
		case BOOKING_SEND_REVIEW_CHAT_ADMIN:
			return {
				...state,
				reviewChatSending: true,
			};

		case BOOKING_SEND_REVIEW_CHAT_ADMIN_SUCCESS:
			return {
				...state,
				reviewChatSending: false,
				sendReviewChatResult: action.payload,
			};
		case BOOKING_READ_REVIEW_CHAT:
			return {
				...state,
				BookingLoading: true,
			};

		case BOOKING_READ_REVIEW_CHAT_SUCCESS:
			return {
				...state,
				BookingLoading: false,
			};
		case LOGOUT_USER:
			return {
				...state,
				BookingLoading: false,
				bookinglist: null,
				bookinglists: null,
				allPaymentBookinglist: null,
				reviewList: [],
				// dataCompanyInformation: null,
			};

		default: return { ...state };
	}
}